// Çalışan Hata Geribildirimleri sayfası (/error-reports) ve pencereleri.
// Kayıtlı durum değerleri (Beklemede, İşlemde, Tamamlandı, İptal) Türkçe kalır;
// Excel dosyası eski düzenini korur.
const errorReports = {
  page: {
    title: 'Çalışan Hata Geribildirimleri',
    subtitle: 'Çalışanların Profil › Hata Bildir’den gönderdiği raporlar. Durumu güncelleyerek takibini yapın.',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Listede görünen raporları Excel olarak indir',
  },
  stats: {
    total: 'Toplam Rapor',
    totalShort: 'Toplam',
    pending: 'Bekleyen',
    pendingShort: 'Bekleyen',
    screenshots: 'Ekran Görüntülü',
    screenshotsShort: 'Görüntülü',
    recent: 'Son 24 Saat',
    recentShort: '24 saat',
    share: 'Tüm raporların %{{percent}}’i',
  },
  toolbar: {
    search: 'Açıklama, kullanıcı adı veya ID ara…',
    searchShort: 'Rapor ara…',
    status: 'Rapor durumu',
    screenshots: 'Ekran görüntülü',
    screenshotsHint: 'Yalnızca ekran görüntüsü eklenmiş raporlar',
    recent: 'Son 24 saat',
    recentHint: 'Yalnızca son 24 saatte gelen raporlar',
    newest: 'En yeni önce',
    oldest: 'En eski önce',
    sortHint: 'Tarihe göre sıralamayı değiştir',
  },
  status: {
    all: 'Tümü',
    pending: 'Beklemede',
    inProgress: 'İşlemde',
    completed: 'Tamamlandı',
    cancelled: 'İptal',
  },
  columns: {
    errorSummary: 'Hata Açıklaması',
    status: 'Durum',
    userName: 'Kullanıcı Adı',
    timestamp: 'Tarih',
    screenshotUrl: 'Ekran Görüntüsü',
    uid: 'Kullanıcı ID',
    deviceInfo: 'Cihaz Bilgisi',
    browserInfo: 'Tarayıcı Bilgisi',
    errorDetails: 'Hata Detayları',
  },
  table: {
    listLabel: 'Hata raporları',
    empty: 'Filtrelere uygun hata raporu bulunamadı',
    rangeOf: '/ {{total}} rapor',
    ofTotal: 'toplam {{total}} rapor içinden',
    jump: 'Sayfaya git',
    noSummary: 'Açıklama yok',
    view: 'Görüntüle',
    none: 'Yok',
    changeStatus: 'Durumu değiştir',
    updatedBy: 'Güncelleyen: {{name}} · {{date}}',
  },
  panel: {
    label: 'Seçili rapor',
    heading: 'Hata raporu',
    screenshot: 'Ekran Görüntüsü',
    details: 'Tüm Detaylar',
    statusTitle: 'Durum',
    updatedBy: '{{name}} güncelledi · {{date}}',
    notUpdated: 'Durum henüz güncellenmedi',
    summary: 'Hata açıklaması',
    screenshotHint: 'Büyütmek için tıklayın',
    withScreenshot: 'Ekran görüntülü',
    markDone: 'Tamamlandı Olarak İşaretle',
    reopen: 'Yeniden Aç (Beklemede)',
    reopenHint: 'Raporu yeniden "Beklemede" durumuna alır',
    user: 'Kullanıcı',
    userId: 'Kullanıcı ID',
    date: 'Tarih',
    device: 'Cihaz',
    browser: 'Tarayıcı',
    updater: 'Durumu güncelleyen',
    updatedAt: 'Güncelleme tarihi',
  },
  details: {
    title: 'Hata Detayları',
    summary: 'Hata Açıklaması',
    user: 'Kullanıcı Bilgileri',
    name: 'Adı',
    id: 'ID',
    date: 'Tarih',
    status: 'Durum',
    updatedBy: 'Güncelleyen',
    updatedAt: 'Güncelleme Tarihi',
    system: 'Sistem Bilgileri',
    device: 'Cihaz',
    browser: 'Tarayıcı',
    detailed: 'Detaylı Hata Bilgisi',
    noInfo: 'Bilgi yok',
    screenshot: 'Ekran Görüntüsü',
    close: 'Kapat',
  },
  screenshot: {
    title: 'Ekran Görüntüsü',
    alt: 'Hata raporunun ekran görüntüsü',
    missing: 'Ekran görüntüsü bulunamadı.',
    openInTab: 'Yeni sekmede aç',
    close: 'Kapat',
  },
  toast: {
    loadError: 'Hata raporları alınırken sorun oluştu',
    notSignedIn: 'Kullanıcı girişi yapılmamış',
    statusUpdated: 'Durum başarıyla güncellendi',
    statusError: 'Durum güncellenirken hata oluştu',
    excelDone: 'Hata raporları indirildi',
    excelError: 'Dosya indirilirken hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default errorReports;
